import React from 'react';
import { Snackbar, IconButton, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';

const CommonSnackbar = ({
  open,
  onClose,
  message,
  type = 'success', // 'success' | 'error'
  autoHideDuration = 4000,
  anchorOrigin = { vertical: 'bottom', horizontal: 'center' }
}) => {
  const isSuccess = type === 'success';
  return (
    <Snackbar
      open={open}
      anchorOrigin={anchorOrigin}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      ContentProps={{
        sx: {
          bgcolor: isSuccess ? '#174ae7' : '#d32f2f',
          color: '#fff',
          borderRadius: 2,
          boxShadow: 0,
          px: 2,
          py: 1,
          minWidth: 220,
          display: 'flex',
          alignItems: 'center'
        }
      }}
      message={
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {isSuccess ? (
            <CheckCircleIcon sx={{ mr: 1, fontSize: 22 }} />
          ) : (
            <ErrorIcon sx={{ mr: 1, fontSize: 22 }} />
          )}
          {message}
        </Box>
      }
      action={
        <IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      }
    />
  );
};

export default CommonSnackbar;
